var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(param,index){return _c('b-row',{key:param.Id,staticClass:"mt-2 mb-2"},[_c('parameter',{attrs:{"definition":param},on:{"changed":_vm.onParametersChanged}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }